import { useEffect, useState } from "react";
import { PanelGenerico } from "../../../components/generic/PanelGenerico";
import { TagDefault } from "../../../components/indicadores/Tags";
import ListaVerificacionService from "../../../services/listaVerificacionService";
import COLORES from "../../../utils/theme/colores";
import { Spinner } from "@fluentui/react";

interface FotosCheckListProps {
  ulrFostos: string[];
  isOpen: boolean;
  dismiss: (
    ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined
  ) => void;
}

//#region
// eslint-disable-next-line jsx-a11y/alt-text
const Foto = ({ ruta }) => (
  <img
    src={`${ruta}`}
    style={{
      maxWidth: 500,
      maxHeight: 600,
      margin: 20,
      padding: 10,
      border: `solid 1px ${COLORES.Bases.primary}`,
      borderRadius: 10,
    }}
  />
);
const FotosHistorial: React.FunctionComponent<FotosCheckListProps> = (prop) => {
  const [listImg64, setListImg64] = useState<string[]>([]);

  const [hiddenSpinner, setHiddenSpinner] = useState(false);
  const [hiddenData, setHiddenData] = useState(true);

  const listaImg = () => {
    const newList: IListLink = { listUrlBase: [] };
    if (prop.ulrFostos.length !== 0) {
      newList.listUrlBase = prop.ulrFostos;
    }
    ListaVerificacionService.listarImgHistorial(newList)
      .then((res) => {
        // console.log(res.data)
        setListImg64(res.data);
        setHiddenSpinner(true);
        setHiddenData(false);
      })
      .catch((e) => {
        alert(e);
      });
  };

  useEffect(() => {
    setHiddenData(true);
    if (prop.isOpen) {
      setHiddenSpinner(false);
      listaImg();
    }
  }, [prop.isOpen]);

  return (
    <>
      <PanelGenerico
        isOpen={prop.isOpen}
        onDismiss={prop.dismiss}
        enabledFooter={true}>
        {/* {prop.ulrFostos.map((url, i) => {
            return (
              <div key={i}>
                <TagDefault bodyMenssaje={`Foto : ${i + 1}`}></TagDefault>
                {/* {url} * /}
                <Foto ruta={url}></Foto>
              </div>
            );
          })} */}
        <div hidden={hiddenSpinner}>
          <Spinner></Spinner>
        </div>

        <div hidden={hiddenData}>
          {listImg64.map((base64Data, i) => {
            return (
              <div key={i}>
                <TagDefault bodyMenssaje={`Foto : ${i + 1}`}></TagDefault>
                {/* {url} */}
                {/* <img
                  src={`data:image/${"png"};base64,${base64Data}`}
                  alt="Image"
                /> */}
                {/* <Foto ruta={`data:image/${"png"};base64,${base64Data}`}></Foto> */}
                <Foto ruta={base64Data}></Foto>
              </div>
            );
          })}
        </div>
      </PanelGenerico>
    </>
  );
};

export default FotosHistorial;
//#endregion

export interface IListLink {
  listUrlBase: string[];
}
